import { createRouteContext } from '@/providers';
import { BudgetOptimizationRoute } from '@/types/routes';

const {
    RouteProvider: BudgetOptimizationRouteProvider,
    useRouteContext: useBudgetOptimizationRoute,
} = createRouteContext<BudgetOptimizationRoute>();

export { BudgetOptimizationRouteProvider, useBudgetOptimizationRoute };
